import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/shop/page.tsx");
